import { useQuery } from "@tanstack/react-query";
import { Lock, Video, BatteryMedium } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { UnlockDoorButton } from "@/components/UnlockDoorButton";
import { DoorCodesToggle } from "@/components/DoorCodesToggle";

export const StudioDevicesCard = () => {
  const { data } = useQuery({ queryKey: ["tuya-devices"], queryFn: () => api.get("/admin/tuya/devices").then((r) => r.data), refetchInterval: 60000 });
  const { admin } = useAuth();
  if (!data?.enabled) return null;
  return (
    <>
    {admin?.role === "super_admin" && (
      <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
        <DoorCodesToggle paused={data.codes_paused} />
        <UnlockDoorButton />
      </div>
    )}
    <div className="grid sm:grid-cols-2 gap-3 mb-6" data-testid="studio-devices">
      {data.devices.map((d, i) => {
        const Icon = /cam/i.test(d.product || "") && !/lock/i.test(d.name || "") ? Video : Lock;
        return (
          <div key={d.id} className="bg-[#111] border border-white/10 rounded-2xl p-4 flex items-center gap-3" data-testid={`device-${i}`}>
            <Icon size={20} className="text-[#D4AF37]" />
            <div className="flex-1 min-w-0">
              <p className="text-white text-sm truncate">{d.name}</p>
              {d.product && d.product !== d.name && <p className="text-white/40 text-xs truncate">{d.product}</p>}
            </div>
            {d.battery != null && <span className={`text-xs flex items-center gap-1 ${d.battery < 15 ? "text-red-400" : d.battery < 30 ? "text-amber-400" : "text-white/50"}`} title={d.battery < 30 ? "Low battery — charge soon" : ""} data-testid={`device-${i}-battery`}><BatteryMedium size={14} />{d.battery}%{d.battery < 30 ? " · low" : ""}</span>}
            <span className={`text-[10px] uppercase font-mono-label px-2 py-1 rounded-full ${d.online ? "bg-green-500/15 text-green-400" : "bg-red-500/15 text-red-400"}`} data-testid={`device-${i}-status`}>{d.online ? "Online" : "Offline"}</span>
          </div>
        );
      })}
    </div>
    </>
  );
};
